import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 bg-canvas px-4 text-center">
      <p className="text-[13px] font-semibold uppercase tracking-wide text-ink-subtle">404</p>
      <h1 className="text-[15px] font-semibold text-ink">This page does not exist</h1>
      <p className="max-w-sm text-[13px] text-ink-muted">
        The address you opened is not part of the admin console. Head back to the transfer log to
        carry on.
      </p>
      <Link
        to="/transfers"
        className="rounded border border-primary bg-primary px-3 py-1.5 text-[13px] font-medium text-ink-inverted hover:bg-primary-hover"
      >
        Go to Transfers
      </Link>
    </main>
  );
}
